// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard/components/respondents-widget-header/respondents-widget-header.component.scss","webpack://./../../01.%20UI/NgHsSurveyClient/src/app/dashboard/components/respondents-widget-header/respondents-widget-header.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;ACCF","sourcesContent":[":host {\r\n  cursor: pointer;\r\n}\r\n",":host {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
